export interface AppState {
  hasError: boolean
  errorSubMessage: string | undefined
  errorMessage: string
  errorDetails: { type?: string; message?: string }
  visibleTerminal: boolean
  leaveToRoute: string | null
  isOnTour: boolean
}

export default {
  hasError: false,
  errorSubMessage: '',
  errorMessage: '',
  errorDetails: {},
  visibleTerminal: false,
  leaveToRoute: null,
  isOnTour: false,
}
